<div class="contenedor" (click)="selection(element)">
  @if (element.selected === true || element.selected === false) {
    <div class="check">
      <label class="checkbox">
        <input
          type="checkbox"
          [(ngModel)]="element.selected">
        <span class="checkmark"></span>
      </label>
      <!-- <input type="checkbox" style="cursor: pointer;" [ngClass]="{'filtroSelect': element.selected}" [checked]="element.selected"> -->
    </div>
  }
  <div class="name" [matTooltip]="element.label" [appOverflowTooltip]="element.label">
    {{element.label}}
  </div>

  @if (element.children && element.children.length !== 0) {
    <div class="check">
      <mat-icon class="icono">chevron_right</mat-icon>
    </div>
  }
</div>